import React,{useEffect,useState,useRef} from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Form,
  Input,
  Spin,
  Button,
  Card,
  message,
  Layout,
  Alert,
} from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import logo from '../../logo.png'
import PortalTitle from '../../component/common/portal.title'
import { login } from '../../store/action/profile.action'
import { Redirect, Link } from 'react-router-dom'
import '../../css/signin.scss'
import util from '../../util/util'
import { constants } from '../../constants'
import { useHistory,useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { setUserDeviceToken,setUserLocation } from '../../store/action/device.action'
import TurnstileWidget from '../../component/common/turnstile.widget'

var { ROLE } = constants

var cardSize =
  (window.innerWidth < window.innerHeight
    ? window.innerWidth
    : window.innerHeight) - 20

cardSize = cardSize < 400 ? cardSize : 400

const MAINTENANCE_POLL_MS = 30 * 1000

const LoginForm = (props) => {
  const [form] = Form.useForm()
  var history = useHistory()
  const location = useLocation();
  const isAdminLite=location.search==constants.ADMIN_LITE;
  const [maintenance, setMaintenance] = useState({ enabled: false, message: null })
  // Turnstile appears only once the server reports captcha_required — i.e. past
  // 3 consecutive failed attempts on this account. See Gate 9 S7 in docs/BUGS.md.
  const [captchaRequired, setCaptchaRequired] = useState(false)
  const captchaTokenRef = useRef(null)
  const capchaResetRef = useRef(null)

  // Poll the unauthenticated healthcheck so the banner appears/clears on its
  // own. The form stays enabled — super admins may log in during maintenance;
  // the server rejects everyone else.
  useEffect(() => {
    let cancelled = false
    const check = () => {
      fetch(`${constants.API_URL}/healthcheck`)
        .then((res) => res.json())
        .then((data) => {
          if (cancelled) return
          const m = (data && data.maintenance) || {}
          setMaintenance({ enabled: !!m.enabled, message: m.message || null })
        })
        .catch(() => {})
    }
    check()
    const timer = setInterval(check, MAINTENANCE_POLL_MS)
    return () => {
      cancelled = true
      clearInterval(timer)
    }
  }, [])

  useEffect(()=>{
      const device = util.getDeviceInfo();

    
    if (!isAdminLite) {
      util.getLocation()
        .then((location) => {
          props.setUserLocation({ location, device });
        })
        .catch((err) => {
          console.warn('Location error:', err);
        });
    }
  },[])

  useEffect(() => {
    if (isAdminLite) {
      const savedEmail = localStorage.getItem('email')

      if (savedEmail) {
        form.setFieldsValue({ username: savedEmail })
      }
    }
  }, [isAdminLite, form])
  const onFinish = async (values) => {

    let trustToken = util.getCookie('trustToken')
    if(isAdminLite && !trustToken){
      trustToken= localStorage.getItem('trustToken');
    } 
   const loginUser= await props.loginUser({email:values.username, password:values.password, trustToken,location:props.location,device:props.device,deviceType:isAdminLite?constants.APPLICATION.AdminLite:constants.APPLICATION.AdminWeb, captchaToken: captchaTokenRef.current})

    // Past 3 consecutive failures the server demands a Turnstile token and
    // answers captcha_required. Show the widget and reset any stale token, so
    // the next attempt carries a fresh one. Never a lock — solving it lets a
    // legitimate clinician straight back in. Added 2026-09-04 with Gate 9 S7;
    // the clinician login previously had no brute-force handling at all.
    if (loginUser && loginUser.captcha_required) {
      setCaptchaRequired(true)
      if (capchaResetRef.current) capchaResetRef.current()
      captchaTokenRef.current = null
    }

   if(isAdminLite){
     handleRoute(loginUser)
    }
    // Only advance to OTP when credentials were accepted.
    //
    // `loginUser` is the profile on success. On failure the action now returns
    // the response instead of undefined — so the CAPTCHA flag above can be read
    // — and that response carries `error: true`. Without this guard a failed
    // login would advance to the OTP screen.
    else if (loginUser && !loginUser.error)
      history.push({ pathname: '/two-step-verification' })
  }

const handleForgotPassword=async()=>{
    const path = `/forgot-password${constants.ADMIN_LITE}`;
       await history.push({ pathname: '/forgot-password', search: constants.ADMIN_LITE });
       if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            route: '/navigate',
            data: { path }
          })
        );
      }
}
  const handleRoute=async(loginUser)=>{
    try{
    
      if(window.ReactNativeWebView){
           let pathName='';
           let path='';
           if(loginUser?.token){
                pathName='/messages';
                path=`/messages${constants.ADMIN_LITE}`
                await props.setUserDeviceToken({userid: loginUser?.user?._id})
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({ route: '/setprofile', data:{token:loginUser?.token,email:loginUser?.user?.email} })
                )
           } 
          else{
              pathName='/two-step-verification';
              path=`/two-step-verification${constants.ADMIN_LITE}`
          }
  
         history.push({ pathname: pathName,search: constants.ADMIN_LITE })
         window.ReactNativeWebView.postMessage(
            JSON.stringify({
              route: '/navigate',
              data: { path }  
            })
          );
      
      }
    }
    catch(err){
      console.log(err,"Error in handleRoute")
    }
  }
  // Land every sign-in on the CURRENT build.
  //
  // <Redirect> is a client-side route change: it never re-fetches index.html,
  // so a browser holding an older shell keeps running the previous bundle for
  // as long as the tab lives. Clinicians leave the admin open all day, which
  // makes this worse here than in the patient app.
  //
  // Observed 2026-09-23: a correctly built and correctly deployed clinic
  // setting was invisible in the admin -- the chunk on disk contained it, the
  // rsync uses --delete so no old bundle survived -- until a hard refresh.
  // Nothing anywhere said why. Clinicians will report the feature as missing.
  //
  // A real navigation re-fetches the document, and index.html is served
  // no-store (nginx, 2026-09-22), so the newest build always wins.
  //
  // Sign-in is the right moment because NOTHING IS IN FLIGHT -- no half-written
  // patient note to lose. Deliberately NOT a forced logout and NOT a
  // mid-session reload; see DESIGN_ZERO_DOWNTIME_DEPLOYS.md §2.1.
  //
  // The admin-lite native shell keeps history.push (handleRoute above): it
  // drives the WebView through postMessage, and a document reload there would
  // fight the shell's own navigation.
  const landingPathFor = (token) => {
    if (token.role == ROLE.COMPANY_ADMIN || token.role == ROLE.COMPANY_HEALTHCOACH)
      return '/customers'
    if (token.role == ROLE.SUPER_ADMIN) return '/companies'
    if (token.role == ROLE.SURGEON) return '/profile/?myprofile=true'
    if (isAdminLite) return '/messages?app=admin-lite'
    return '/compliance'
  }

  if (props.token != undefined && !window.ReactNativeWebView) {
    const to = landingPathFor(props.token)
    // Cache-busting param: the CRA shell can be served from cache even with
    // no-store upstream (proxies, WebViews), and the same trick is used after
    // a maintenance window in the patient app for exactly this reason.
    const sep = to.indexOf('?') === -1 ? '?' : '&'
    window.location.href = to + sep + 'rb=' + Date.now()
    return null
  }

  return props.token != undefined ? (
    props.token.role == ROLE.COMPANY_ADMIN ||
    props.token.role == ROLE.COMPANY_HEALTHCOACH ? (
      <Redirect to='/customers' />
    ) : props.token.role == ROLE.SUPER_ADMIN ? (
      <Redirect to='/companies' />
    ) : props.token.role == ROLE.SURGEON ? (
      // <Redirect to="/profile/?myprofile=true" /> : <Redirect to="/home" />) :
      <Redirect to='/profile/?myprofile=true' />
    ) : isAdminLite?(
          <Redirect to={{ pathname: "/messages", search: "app=admin-lite" }} />
        ): (
      <Redirect to='/compliance' />
    )
  ) : (
    <>
      <Spin spinning={props.isLoading}>
        <Row type='flex' align='middle' className='signinRow center'>
          <Col span={24} flex='auto'>
            <div className='signinContainer'>
              {/* Column wrapper: signinContainer is a row-flex center, so the
                  banner must stack above the card, not sit beside it. */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
              {maintenance.enabled && (
                <Alert
                  type='warning'
                  showIcon
                  banner
                  style={{ width: cardSize, marginBottom: 12 }}
                  message='System maintenance in progress'
                  description={
                    maintenance.message ||
                    'The platform is temporarily offline for updates. Login will be available again as soon as maintenance is complete.'
                  }
                />
              )}
              <Card style={{ width: cardSize, height: cardSize }}>
                <div className='imageBox center'>
                  <img
                    src={logo}
                    width={cardSize / 2}
                    style={{ paddingBottom: cardSize / 20 }}
                  />
                </div>
                <PortalTitle />
                <div className='header center'>
                  <h1>Sign In</h1>
                </div>
                <Form
                  form={form}
                  name='normal_login'
                  className='login-form'
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                >
                  <Form.Item
                    name='username'
                    rules={[
                      {
                        required: true,
                        message: 'Please input your Username!',
                      },
                    ]}
                  >
                    <Input
                      prefix={<UserOutlined className='site-form-item-icon' />}
                      placeholder='Username'
                    />
                  </Form.Item>
                  <Form.Item
                    name='password'
                    rules={[
                      {
                        required: true,
                        message: 'Please input your Password!',
                      },
                    ]}
                  >
                    <Input
                      prefix={<LockOutlined className='site-form-item-icon' />}
                      type='password'
                      placeholder='Password'
                    />
                  </Form.Item>
                  {/* Only after the server says so — a CAPTCHA on every login
                      would be friction for the 99% of sign-ins that are a
                      clinician typing their own password correctly. */}
                  {captchaRequired && (
                    <Form.Item>
                      <div style={{ marginBottom: 8, fontSize: 13 }}>
                        Too many failed attempts. Please complete the security
                        check to continue.
                      </div>
                      <TurnstileWidget
                        onToken={(t) => { captchaTokenRef.current = t }}
                        resetRef={capchaResetRef}
                        tokenRef={captchaTokenRef}
                      />
                    </Form.Item>
                  )}
                  <Form.Item className={isAdminLite?'forgot-input':''}>
                    {!isAdminLite &&<Link to='/forgot-password' style={{ float: 'left' }}>
                      Forgot password
                    </Link>}
                    {isAdminLite &&(<Button type='link' onClick={handleForgotPassword} style={{ float: 'left' }}>
                      Forgot password
                    </Button>)}
                  </Form.Item>
                  <Form.Item>
                    <div className='center'>
                      <Button
                        type='primary'
                        htmlType='submit'
                        className='login-form-button'
                      >
                        SIGN IN
                      </Button>
                    </div>
                  </Form.Item>
                </Form>
              </Card>
              </div>
            </div>
            <Layout.Footer className='main-footer'>
              {util.getCopyrightText()}
            </Layout.Footer>
          </Col>
        </Row>
      </Spin>
    </>
  )
}

LoginForm.propTypes = {
  loginUser: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    hasError: state.profile.error,
    message: state.profile.message,
    isLoading: state.profile.isLoading,
    location:state.device.location,
    device:state.device.device,
    token: util.verifyToken(state.profile.token, true),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loginUser: (input) => dispatch(login(input)),
    setUserDeviceToken: (input) => dispatch(setUserDeviceToken(input)),
    setUserLocation : (input) => dispatch(setUserLocation(input)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)
